import '@styles/index.css';
import React, { useState } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { RootState } from '@store/store';
import { setPassword } from '@store/reducers/auth/signupSlice';
import { useTranslation } from 'react-i18next';
import { IoEyeOffOutline, IoEyeOutline } from 'react-icons/io5';
import ErrorMessage from '@components/Error/ErrorMessage';
import {
    PASSWORD_MIN_Length,
    PASSWORD_MAX_Length,
    PASSWORD_PATTERN,
    PASSWORD_TITLE,
} from '@constants/form';

const SetPassword = () => {
    const userPassword = useSelector(
        (state: RootState) => state.signup.password
    );
    const [password, setUserPassword] = useState(userPassword);
    const [confirmPassword, setConfirmPassword] = useState(userPassword);
    const [showPassword, setShowPassword] = useState(false);
    const [showConfirmPassword, setShowConfrimPassword] = useState(false);
    const [error, setError] = useState<string | null>(null);
    const dispatch = useDispatch();
    const { t } = useTranslation();

    const handlePasswordChange = (
        event: React.ChangeEvent<HTMLInputElement>
    ) => {
        setUserPassword(event.target.value);
        setError(null);
    };

    const handleConfirmPasswordChange = (
        event: React.ChangeEvent<HTMLInputElement>
    ) => {
        setConfirmPassword(event.target.value);
        if (event.target.value !== password) {
            setError('Passwords do not match');
        } else {
            dispatch(setPassword(event.target.value));
            setError(null);
        }
    };

    const handleTogglePasswordVisibility = () => {
        setShowPassword((prevShowPassword) => !prevShowPassword);
    };

    const handleToggleConfirmPasswordVisibility = () => {
        setShowConfrimPassword(
            (prevShowConfirmPassword) => !prevShowConfirmPassword
        );
    };

    return (
        <div>
            {error && <ErrorMessage message={error} />}
            <div className="relative">
                <label
                    htmlFor="password"
                    className="block mb-2 text-sm font-medium text-light_grey"
                >
                    {t('auth.signup.password_label')}
                </label>
                <div className="relative flex items-center rounded-md">
                    <input
                        type={showPassword ? 'text' : 'password'}
                        name="password"
                        id="signup_password"
                        value={password}
                        onChange={handlePasswordChange}
                        className="form-control px-3 py-2 placeholder-custom"
                        placeholder={t('auth.signup.password_placeholder')}
                        required
                        minLength={PASSWORD_MIN_Length}
                        maxLength={PASSWORD_MAX_Length}
                        pattern={PASSWORD_PATTERN}
                        title={PASSWORD_TITLE}
                        aria-describedby="password"
                        autoComplete="new-password"
                    />
                    <button
                        type="button"
                        className="absolute right-3 cursor-pointer"
                        onClick={handleTogglePasswordVisibility}
                    >
                        {showPassword ? (
                            <IoEyeOutline className="text-secondary" />
                        ) : (
                            <IoEyeOffOutline className="text-secondary" />
                        )}
                    </button>
                </div>
            </div>
            <div className="relative mt-3">
                <label
                    htmlFor="password"
                    className="block mb-2 text-sm font-medium text-light_grey"
                >
                    {t('auth.signup.confirm_password_label')}
                </label>
                <div className="relative flex items-center rounded-md">
                    <input
                        type={showConfirmPassword ? 'text' : 'password'}
                        name="password"
                        id="confirm_password"
                        value={confirmPassword}
                        onChange={handleConfirmPasswordChange}
                        className="form-control px-3 py-2 placeholder-custom"
                        placeholder={t(
                            'auth.signup.confirm_password_placeholder'
                        )}
                        minLength={PASSWORD_MIN_Length}
                        maxLength={PASSWORD_MAX_Length}
                        pattern={PASSWORD_PATTERN}
                        required
                        title={PASSWORD_TITLE}
                        aria-describedby="confirm_password"
                        autoComplete="new-password"
                    />
                    <button
                        type="button"
                        className="absolute right-3 cursor-pointer"
                        onClick={handleToggleConfirmPasswordVisibility}
                    >
                        {showConfirmPassword ? (
                            <IoEyeOutline className="text-secondary" />
                        ) : (
                            <IoEyeOffOutline className="text-secondary" />
                        )}
                    </button>
                </div>
            </div>
        </div>
    );
};

export default SetPassword;
